import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { DocumentRegistry } from 'shell/models/document-registry';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface SelectRegistryProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  id: string;
  label?: string;
  error?: boolean;
  isSmallSize?: boolean;
}

const SelectRegistryComponent = ({
  disabled = false,
  onChange,
  value,
  id,
  label,
  error = false,
  isSmallSize = false,
}: SelectRegistryProps): React.ReactElement => {
  const [series] = useHttpFetch<HttpResponseList<DocumentRegistry>, Array<ItemVM>>(
    `${__CIVIL_STATUS_API_URL__}/registro-atto`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
      },
      transformer: (response) =>
        (response?.data?.payload?.list || []).map((item) => ({
          id: item.key?.codiceRegistro || '',
          value: item.key?.codiceRegistro || '',
        })),
    }
  );

  const seriesData = (series.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error}>{label}</InputLabel>
      <PmiSelect
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        label={label}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        <MenuItem value="">Nessuno</MenuItem>
        {seriesData.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SelectRegistryComponent.displayName = 'List registry component';

const SelectRegistry = memo(SelectRegistryComponent);

export default SelectRegistry as typeof SelectRegistryComponent;
